import Table from '@material-ui/core/Table'
import type { PaginationProps } from 'elements/list/ListTable'
import { styled } from 'opensolar-ui'
import { memo } from 'react'
import EmptyState from './EmptyState'
import ProjectTablePagination from './Pagination'
import ProjectTableSkeleton from './ProjectTableSkeleton'
import { MPO_TABLE_MIN_WIDTH } from './TableHeader'

const TableScrollContainer = styled('div')({
  width: '100%',
  minWidth: 0,
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
})

const StyledTable = styled(Table)({
  tableLayout: 'fixed',
  width: '100%',
  minWidth: MPO_TABLE_MIN_WIDTH,
})

const LoadingContainer = styled('div')({
  padding: '16px',
})

const EmptyStateContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  width: '100%',
})

type TableContainerProps = PaginationProps & {
  loaded: boolean
  loading: boolean
  children: JSX.Element | JSX.Element[]
  hasFilters?: boolean
}

const TableContainer = ({
  loaded,
  loading,
  children,
  total,
  query,
  queryPresenter,
  hasFilters = false,
}: TableContainerProps) => {
  if (loaded === false) {
    return (
      <LoadingContainer>
        <TableScrollContainer>
          <ProjectTableSkeleton />
        </TableScrollContainer>
      </LoadingContainer>
    )
  }

  if (total === 0 && loading === false) {
    return (
      <EmptyStateContainer>
        <EmptyState hasFilters={hasFilters} />
      </EmptyStateContainer>
    )
  }

  return (
    <>
      <TableScrollContainer>
        <StyledTable size="small">
          {children}
        </StyledTable>
      </TableScrollContainer>
      <ProjectTablePagination total={total} query={query} queryPresenter={queryPresenter} />
    </>
  )
}

export default memo(TableContainer)
